import { coreInitiativesStatusesGetAsyncSlice } from './get';

export const { requestGetCoreInitiativesStatuses, resetGetCoreInitiativesStatuses } =
	coreInitiativesStatusesGetAsyncSlice.asyncActionCreators;
